/** Phase 5 message files, one per task so parallel builders never share a file (docs/SHARED-RECEPTION-PLAN.md). */
import { srArchEnGB } from './sr-arch.js';
import { cSr1EnGB } from './c-sr1.js';
import { cSr2EnGB } from './c-sr2.js';
import { sSr1EnGB } from './s-sr1.js';
import { sSr2EnGB } from './s-sr2.js';
import { sSr3EnGB } from './s-sr3.js';
import { sSr4EnGB } from './s-sr4.js';
import { wSr1EnGB } from './w-sr1.js';
import { wSr2EnGB } from './w-sr2.js';
import { wSr3EnGB } from './w-sr3.js';
import { kSr1EnGB } from './k-sr1.js';
import { kSr2EnGB } from './k-sr2.js';
import { mSrEnGB } from './m-sr.js';
import { dSrLegalEnGB } from './d-sr-legal.js';
import { fxSr1EnGB } from './fxsr1.js';
import { secSr1EnGB } from './secsr1.js';
export const phase5EnGB = {
    ...srArchEnGB,
    ...cSr1EnGB,
    ...cSr2EnGB,
    ...sSr1EnGB,
    ...sSr2EnGB,
    ...sSr3EnGB,
    ...sSr4EnGB,
    ...wSr1EnGB,
    ...wSr2EnGB,
    ...wSr3EnGB,
    ...kSr1EnGB,
    ...kSr2EnGB,
    ...mSrEnGB,
    ...dSrLegalEnGB,
    ...fxSr1EnGB,
    ...secSr1EnGB,
};
//# sourceMappingURL=index.js.map